module.exports = __webpack_public_path__ + "static/media/item7.4fbd9be4.jpg";